@if (loading()) {
  <div class="flex items-center p-3">
    <p-progressSpinner size="small"></p-progressSpinner>
    <span class="ml-2 text-500">Loading severity impact data...</span>
  </div>
}

@if (!loading()) {
  <p-panel>
    <ng-template pTemplate="header">
      <div class="flex justify-between items-center w-full">
        <div>
          <h4 class="text-xl font-semibold m-0 mb-2">Severity & Impact Assessment</h4>
          @if (severityImpact()) {
            <p class="text-sm text-500 m-0">
              Assessment completed on {{ severityImpact()?.dateCreated | date:'medium' }}
              @if (severityImpact()?.dateUpdated) {
                <span>
                  (Updated on {{ severityImpact()?.dateUpdated | date:'medium' }})
                </span>
              }
            </p>
          }
          @if (!severityImpact()) {
            <p class="text-sm text-500 m-0">
              No assessment has been completed for this incident.
            </p>
          }
        </div>
        <button pButton
          type="button"
          icon="pi pi-pencil"
          class="p-button-outlined p-button-sm"
          (click)="onEditClick()"
          label="Edit">
        </button>
      </div>
    </ng-template>
    <ng-template pTemplate="content">
      <div class="grid gap-4">
        <div class="col-span-12">
          <h5 class="text-sm font-semibold text-700 uppercase tracking-wide mb-2">Personal Injury</h5>
          @if (severityImpact()) {
            <p class="text-900 font-medium m-0">{{ getPersonalInjuryLabel(severityImpact()?.personalInjuryLevel || 0) }}</p>
          }
          @if (!severityImpact()) {
            <p class="text-500 italic m-0">Not specified</p>
          }
        </div>
        <div class="col-span-12">
          <h5 class="text-sm font-semibold text-700 uppercase tracking-wide mb-2">Financial Impact</h5>
          @if (severityImpact()) {
            <p class="text-900 font-medium m-0">{{ getFinancialImpactLabel(severityImpact()?.financialImpactLevel || 0) }}</p>
          }
          @if (!severityImpact()) {
            <p class="text-500 italic m-0">Not specified</p>
          }
          @if (severityImpact()?.financialAmount) {
            <p class="text-green-600 font-semibold text-sm mt-1 m-0">
              Amount: {{ formatCurrency(severityImpact()?.financialAmount || 0) }}
            </p>
          }
        </div>
        <div class="col-span-12">
          <h5 class="text-sm font-semibold text-700 uppercase tracking-wide mb-2">Additional Notes</h5>
          @if (severityImpact()?.additionalNotes) {
            <p class="text-600 leading-relaxed m-0 whitespace-pre-wrap">{{ severityImpact()?.additionalNotes }}</p>
          }
          @if (!severityImpact()?.additionalNotes) {
            <p class="text-500 italic m-0">Not specified</p>
          }
        </div>
      </div>
    </ng-template>
  </p-panel>
}